'use strict';

require('../shared/base-entry');
require('./views/home');
require('../shared/post-entry');
